// extracted by mini-css-extract-plugin
export var authorCard = "X_c4";
export var authorCardContent = "X_c6";
export var authorCardImage = "X_c5";
export var bottom = "X_dc";
export var description = "X_db";
export var name = "X_c8";
export var role = "X_c9";
export var top = "X_c7";